import React from "react";
import { Typography, Layout } from "antd";

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const CookiePolicy = () => {
  return (
    <Layout style={{ background: "#fff" }}>

      <Content
        style={{ padding: "60px 80px", maxWidth: 1000, margin: "0 auto", marginTop: "-40px", }}
        data-aos="fade-up"
      >
        {/* Header Title Box */}
        <div
          style={{
            height: "50px",
            width: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "20px auto",
            borderRadius: "20px",
            padding: "20px",
          }}
          data-aos="fade-up"
        >
          <Title level={2} style={{ margin: 0 }}>
            Cookie Policy
          </Title>
        </div>

        <Typography data-aos="fade-up">
          <Paragraph>
            <Text strong>Effective Date:</Text> 1 November 2025
          </Paragraph>

          <Title level={4}>1. Introduction</Title>
          <Paragraph>
            This Cookie Policy explains how <Text strong>Yalla Nellab</Text> ("we", "us", "our") uses
            cookies and similar tracking technologies on our website and associated services. By
            using our website, you accept the use of cookies as described in this policy.
          </Paragraph>

          <Title level={4}>2. What Are Cookies?</Title>
          <Paragraph>
            Cookies are small files placed on your device (computer, tablet, mobile) when you visit a
            website. They help the website recognize your device, improve functionality and provide
            information about how you use the site.
          </Paragraph>

          <Title level={4}>3. Cookies We Use</Title>
          <Paragraph>
            We use analytics cookies (for example from tools such as Google Analytics) to collect
            information about how users access and use our website, including your IP address,
            browser type and pages visited.
          </Paragraph>
          <Paragraph>
            We use advertising cookies (first-party) to support advertising initiatives linked to our
            events and services.
          </Paragraph>
          <Paragraph>
            We do not use third-party advertising networks or share your cookie data with external
            advertising partners.
          </Paragraph>
          <Paragraph>
            The cookies we set are session cookies — they expire when you close your browser session
            (i.e., they are not persistent cookies stored beyond your browsing session).
          </Paragraph>

          <Title level={4}>4. Purpose of Cookies</Title>
          <Paragraph>We use cookies to:</Paragraph>
          <ul>
            <li>
              Understand how users engage with our website, so we can improve our content and user
              experience.
            </li>
            <li>
              Provide you with relevant information about upcoming events and services organized by
              Yalla Nellab.
            </li>
            <li>Support our internal metrics and event-planning efforts.</li>
          </ul>

          <Title level={4}>5. Your Choices</Title>
          <Paragraph>
            You may disable or delete cookies via your browser settings (for example: Settings → Privacy
            → Cookies in your browser). Please note that without cookies some features or functionality
            of our website may not work as smoothly.
          </Paragraph>

          <Title level={4}>6. Retention and Data Associated with Cookies</Title>
          <Paragraph>
            Since our cookies are session cookies, they expire when you close your browser. We do not
            retain any persistent tracking via cookies beyond that session. Data collected via cookies
            (e.g., analytics data including IP address) is stored and processed in accordance with our
            broader data retention and security practices.
          </Paragraph>

          <Title level={4}>7. Updates to This Cookie Policy</Title>
          <Paragraph>
            We may update this Cookie Policy from time to time. The "Effective Date" at the top will
            reflect the date of the most recent update. It is your responsibility to review this
            policy periodically to stay informed about our cookie practices.
          </Paragraph>

          <Title level={4}>8. Contact Us</Title>
          <Paragraph>
            If you have any questions or concerns about our use of cookies, please contact us through
            contact us form.
          </Paragraph>
        </Typography>
      </Content>
    </Layout>
  );
};

export default CookiePolicy;